import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type FC } from "react";

import LogoMarkSvg from "~/assets/icons/logo-mark.svg?react";

export const LogoMarkIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={LogoMarkSvg} inheritViewBox />
);
